import { useAppDispatch, useAppSelector } from "hooks";
import React, { useEffect, useState } from "react";
import { simFlowFetchData, simFlowFetchSimRequestData } from "../../../../redux/simFlow/simFlowSlice";
import CommonLoader from "components/CommonLoader";
import { isValidXML, parseXml } from "utils/commonFunctions";

type PublishLegacyBackfillProps = {
  id: any;
};

function PublishLegacyBackfill({ id }: PublishLegacyBackfillProps) {
  // eslint-disable-next-line sonarjs/no-duplicate-string
  const simSelectorData = useAppSelector((state) => state.simFlow.simFlow.data[5].data);
  const [simSelector, setSimSelector] = React.useState<any>(simSelectorData);
  const simError = useAppSelector((state) => state.errorStep.simError);
  const isError = simError ? simError.step >= 12 : false;
  const isAlreadyFetched =
    simSelectorData instanceof Array
      ? false
      : "status" in simSelectorData
        ? true
        : simSelectorData.flow_dtl_id === Number(id);

  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!isError && !isAlreadyFetched) {
      dispatch(simFlowFetchData());
      dispatch(simFlowFetchSimRequestData({ id, stepId: 12 }));
    } else {
      setSimSelector(simSelectorData);
    }
  }, [dispatch, id, isAlreadyFetched, isError, simSelectorData]);

  const simSelectorLoading = useAppSelector((state) => state.simFlow.simFlow.loading);
  // const [requestData] = React.useState<any>(simSelector.request_json);
  // const [responseData] = React.useState<any>(simSelector.response_json);
  // const filteredIlaFactory = responseData?.accessoryDetail?.filter((item: any) => item.accessoryType === "F");
  // const filteredIlaPPo = responseData?.accessoryDetail?.filter((item: any) => item.accessoryType === "P");
  const [xmlData, setXmlData] = useState<any>();

  useEffect(() => {
    const paraseXmltoJSONResponse = async () => {
      if (simSelector.request_xml && (await isValidXML(simSelector.request_xml))) {
        const value = await parseXml(simSelector.request_xml);
        // console.log(value);
        setXmlData(value === false ? "Error parsing TOMS XML Data !!!" : value.xmlData);
      }
    };

    paraseXmltoJSONResponse();
  }, [simSelector]);

  // console.log(xmlData);

  const vehicleIdentifierData: Array<any> = [
    {
      id: 1,
      name: "URN",
      value: xmlData?.requestedMessage[0]?.urn[0] ?? "",
    },
    {
      id: 2,
      name: "Model Year",
      value: xmlData?.requestedMessage[0]?.modelYear[0] ?? "",
    },
  ];
  const kafkaResponse = (kafaka: any) => {
    // console.log("kafaka", kafaka);
    let vehicleIdentifier;
    if (kafaka) {
      vehicleIdentifier = kafaka.NVSAcknowledgementMsg.Response[0];
    } else {
      vehicleIdentifier = {
        ResponseCde: ["-1"],
        ResponseTxt: "No acknowledgement received",
      };
    }
    // console.log(vehicleIdentifier);
    return {
      "Acknowledgement Status": vehicleIdentifier.ResponseCde[0] === "00" ? "SUCCESS" : "ERROR",
      "Acknowledgement Response": vehicleIdentifier.ResponseTxt,
    };
  };
  const acknowledgementData: Array<any> = [
    {
      id: 1,
      name: "Has VOC Posted Message to Kafka",
      value: simSelector?.kafReqProcessFlag ? "Yes" : "No",
    },
    {
      id: 2,
      name: "Acknowledgement Status",
      value: kafkaResponse(simSelector?.kafRespResponseJson)?.["Acknowledgement Status"],
    },
    {
      id: 3,
      name: "Aknowledgement Response",
      value: kafkaResponse(simSelector?.kafRespResponseJson)?.["Acknowledgement Response"],
    },
  ];
  const applicationAreaData: Array<any> = [
    {
      id: 1,
      name: "BOD ID",
      value: simSelector?.bod_id ?? "",
    },
    {
      id: 2,
      name: "Creator Code",
      value: xmlData?.applicationArea[0]?.creatorCode[0] ?? "",
    },
    {
      id: 3,
      name: "Event",
      value: xmlData?.applicationArea[0]?.event[0] ?? "",
    },
  ];

  const renderData: Array<any> = [
    {
      id: 1,
      title: "Vehicle Identifier",
      data: vehicleIdentifierData,
    },
    {
      id: 2,
      title: "Acknowledgement",
      data: acknowledgementData,
    },
    {
      id: 3,
      title: "Application Area",
      data: applicationAreaData,
    },
  ];
  // console.log("renderData", RequestedConfiguration[4]);
  useEffect(() => {
    // console.log("requestData", nsoSelector);
  }, [simSelector]);

  if (simSelectorLoading) {
    return <CommonLoader active={simSelectorLoading} />;
  }

  return (
    <>
      <div className="border border-gray-300 rounded-lg shadow-lg gap-4">
        {renderData.map((item) => {
          return (
            <div className="w-full bg-gray-100 rounded-lg py-2 m-2" key={item.id}>
              <div className="flex w-full justify-start items-center content-center">
                <span className="font-bold mx-4 text-xl">{item.title}</span>
              </div>
              <div className="border border-gray-300 rounded-lg my-2 mx-0"></div>
              <div className="grid grid-cols-3 m-4 gap-4">
                {item.data.map((items: any) => (
                  <div className="" key={items.id}>
                    <div className="bg-yellow grid grid-cols-2 m-2 gap-4">
                      <div className="text-base">{items.name}</div>
                      {item.name === "Factory" || item.name === "PPO" ? (
                        <div className="text-base"></div>
                      ) : (
                        <div className="text-base whitespace-pre-wrap break-words ">{items.value}</div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}

export default PublishLegacyBackfill;
